import { Injectable } from '@angular/core';
import { BaseApiService } from '../base-api/base-api.service';
import { Observable } from 'rxjs';
import { GLOBAL_API_PATHS } from 'src/assets/constants/apiPaths';

@Injectable({
  providedIn: 'root'
})
export class UserFormCognitoService {

  constructor(private readonly baseApiService: BaseApiService) { }

  /**
   * authenticateEmailToken() - Method to authenticate the email token and fetch the data
   * @param token auth token
   * @returns form data
   */
  authenticateEmailToken(token: any): Observable<any> {
    const url = GLOBAL_API_PATHS.cognito_email_token + `token=${token}`;
    return this.baseApiService.get(url);
  }
}
